














import { Component, Vue, Prop } from 'vue-property-decorator'
import WarningForm from './WarningForm.vue'
import { Warning, AddWarning } from '../store/warning'
import { namespace } from 'vuex-class'
const warningStore = namespace('warning')
@Component({ components: { WarningForm } })
export default class EditWarningModal extends Vue {
  dialog = false
  @warningStore.Action edit!: (warning: Warning) => Promise<Warning>
  @Prop() warning!: Warning

  async editWarning(warning: AddWarning) {
    await this.edit({ id: this.warning.id, ...warning })
    this.dialog = false
  }
}
